// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"bbf5fb28","488":"5f19b596","542":"3f9cf8f3","667":"be8dd586","977":"68319f32"}[chunkId] + ".chunk.js";
};